
/* injects from baggage-loader */
require('./style.styl');

import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import VerticalTabs from 'components/VerticalTabs'
import {Table, Column, Cell} from 'components/Table'
import Icon from 'components/Icon'
import {connect} from 'react-redux'
import get from 'lodash/get'
import {channels} from 'redux/modules/channels/utils'
import {push as pushState} from 'react-router-redux'
import {channelGroups, channelTypes} from '@divvit/common-channels'
import {fetchMappingsForChannel} from 'redux/modules/settings/actions'
import {
  fetchIntegrations,
  fetchIntegrationInfo,
  fetchIntegrationCosts,
  disconnectIntegration
} from 'redux/modules/integrations/actions'
import {
  showAddNewSpreadSheet,
  showAddManualInput,
  showAddCriteo
} from 'redux/modules/ui/modal/actions'
import {
  getChannelIntegrations,
  getGroupedIntegrations,
  getIntegrationCosts,
  getAuthorizationURLParams,
  integrationTypes
} from 'redux/modules/integrations/selectors'
import {getChannelMappings} from 'redux/modules/settings/selectors'
import {getCurrentSite, getCurrentMerchant} from 'redux/modules/currentUser/selectors'
import TimeAgo from 'components/TimeAgo'
import Loader from 'components/Loader'
import Integration from 'components/Integration'
import NumberFormat from 'components/NumberFormat'
import propsChanged from 'utils/propsChanged'
import moment from 'moment'
import classnames from 'classnames'
import * as _ from 'lodash'

const channelTypeKeys = _.keys(channelTypes).filter(str => !!str).map(str => `"${str}"`). join(" / ")

export class SettingsChannelsView extends React.Component {
  static propTypes = {
    channelGroupId: PropTypes.string,
    channelId: PropTypes.string,
    integrationId: PropTypes.string,
    today: PropTypes.instanceOf(Date),
    fetchMappingsForChannel: PropTypes.func,
    fetchIntegrationCosts: PropTypes.func,
    showAddNewSpreadSheet: PropTypes.func,
    fetchIntegrationInfo: PropTypes.func,
    showAddManualInput: PropTypes.func,
    showAddCriteo: PropTypes.func,
    authorizationURLParams: PropTypes.object,
    pushState: PropTypes.func,
    integrationCosts: PropTypes.array,
    groupedIntegrations: PropTypes.object,
    fetchIntegrations: PropTypes.func,
    disconnectIntegration: PropTypes.func,
    mappings: PropTypes.array,
    isBusy: PropTypes.bool,
    currentSite: PropTypes.object,
    integrations: PropTypes.array,
    isCostsFetching: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object,
    timezone: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedNewIntegration: null
    }
  }

  componentWillMount() {
    const {
      channelGroupId,
      channelId,
      fetchMappingsForChannel,
      fetchIntegrations
    } = this.props

    fetchIntegrations()

    if (!channelGroupId || !channelId) return

    fetchMappingsForChannel(channelGroupId, channelId)
  }

  componentWillReceiveProps(nextProps) {
    if (propsChanged(this.props, nextProps, ['channelGroupId', 'channelId', 'integrationId', 'isBusy'])) {
      const {
        channelGroupId,
        channelId,
        fetchMappingsForChannel,
        fetchIntegrationInfo,
        fetchIntegrations,
        integrationId,
        isBusy
      } = nextProps
      if (!channelGroupId || !channelId) return

      fetchMappingsForChannel(channelGroupId, channelId)
      fetchIntegrations()

      if (integrationId && !isBusy && this.props.isBusy) {
        fetchIntegrationInfo(integrationId, channelGroupId, channelId)
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {fetchIntegrationCosts, today, integrationId} = this.props
    const {timezone} = this.context
    if (propsChanged(this.props, prevProps, ['integrationId']) && integrationId) {
      const startDate = moment(today).clone().subtract(1, 'weeks').toDate()
      const endDate = moment(today).clone().toDate()
      fetchIntegrationCosts(integrationId, startDate, endDate, timezone)
    }
  }

  render() {
    return (
      <div className='settings-channels-view container'>
        <div className='settings-channels-view_channel-groups'>
          {this.renderChannelGroups()}
        </div>
        <div className='settings-channels-view_channel-groups-info'>
          {this.renderChannels()}
          {this.renderChannelInfo()}
        </div>
      </div>
    )
  }

  renderChannelGroups() {
    const {channelGroupId, groupedIntegrations} = this.props

    return (
      <VerticalTabs
        items={Object.keys(channelGroups).map(key => {
          const item = channelGroups[key]
          const integrations = get(groupedIntegrations, `${key}.count`, 0)

          return {
            ...item,
            to: `/settings/channels/${key}`,
            badge: integrations
          }
        })}
        activeItemId={channelGroupId} />
    )
  }

  renderChannels() {
    const {channelGroupId, groupedIntegrations} = this.props
    const groupChannels = Object.keys(channels).reduce((acc, key) => {
      const channel = channels[key]
      if (channel.groupId === channelGroupId) {
        const integrations = get(groupedIntegrations, `${channelGroupId}.items.${channel.channelId}`, [])

        return acc.concat({
          ...channel,
          to: `/settings/channels/${channelGroupId}/${channel.channelId}`,
          iconName: `channel-${channel.channelId}`,
          badge: integrations.length
        })
      }
      return acc
    }, [])

    return (
      <div className='settings-channels-view_channels'>
        <VerticalTabs
          className='settings-channels-view_channel-list'
          items={groupChannels}
          activeItemId={channelGroupId} />
      </div>
    )
  }

  renderChannelInfo() {
    const {channelGroupId, channelId} = this.props
    if (!channelId) return null

    const channel = channels[`${channelGroupId}/${channelId}`]
    const group = channelGroups[channelGroupId]

    return (
      <div className='settings-channels-view_channel-info'>
        <div className='settings-channels-view_channel-title'>
          <div className='settings-channels-view_channel-title_group'>{group.label}</div>
          <div className='settings-channels-view_channel-title_name'>
            <Icon
              className='settings-channels-view_channel-title_icon'
              name={`channel-${channelId}`}
              size='35px' />
            {channel.label}
          </div>
        </div>
        <div className='settings-channels-view_channel-desc'>
          Your traffic will be mapped into this channel according to the following rules:
        </div>
        {this.renderURLSection()}
        {this.renderGASection()}
        {this.renderIntegrations()}
      </div>
    )
  }

  renderURLSection() {
    const {channelGroupId, channelId} = this.props

    return (
      <div className='settings-channels-view_channel-section'>
        <div className='settings-channels-view_channel-section_title'>
          URL Parameters
        </div>
        <div className='settings-channels-view_channel-section_content'>
          Append <span className='marked'>
            {`dgr=${channelGroupId}&dch=${channelId}`}
          </span> to the URLs that you publish.
          <br/>
          <br/>
          For channel type add  
          <span className='marked'>
            {`&dty=...`}
          </span> with <span className='marked'>
            {`"..."`}
          </span> as one of the options: <span className='marked'>
            {channelTypeKeys}
          </span>
        </div>
      </div>
    )
  }

  renderGASection() {
    const {mappings} = this.props
    if (!mappings) return null

    return (
      <div className='settings-channels-view_channel-section'>
        <div className='settings-channels-view_channel-section_title'>
          Google Analytics URL parameters
        </div>
        <div className='settings-channels-view_channel-section_content'>
          If we encounter the following utm_parameters we will map to this channel:
          <ul>
            {mappings.map((item, index) => {
              return <li key={index}>?{this.renderMapping(item)}</li>
            })}
          </ul>
        </div>
      </div>
    )
  }

  renderMapping(item) {
    const values = Object.keys(item)
      .filter(key => !!item[key])
      .reduce((acc, key, index, arr) => {
        if (!item[key]) return acc
        const postfix = (index !== (arr.length - 1)) ? '&' : ''
        const mapping = (
          <span key={index}>
            {key}=<span className='marked'>{item[key]}</span>{postfix}
          </span>
        )
        return acc.concat(mapping)
      }, [])

    return (
      <span>{values}</span>
    )
  }

  renderIntegrations() {
    const {integrations, isBusy, integrationId} = this.props
    const {selectedNewIntegration} = this.state

    if (!integrations) return null

    const classNames = classnames('settings-channels-view_integrations', {
      'is-loading': isBusy
    })

    return (
      <Fragment>
        <div className={classNames}>
          {isBusy ? <Loader /> : null}
          <h3 className='integrations_title'>Cost Integrations</h3>
          <div>
            {integrations.map((integration, index) => {
              const {connected, serviceId, id, icon, costConfig, title} = integration
              const {name} = costConfig || {}
              const expanded = connected ? integrationId === id : selectedNewIntegration === serviceId
              return (
                <Integration
                  key={index}
                  expanded={expanded}
                  connected={connected}
                  serviceId={serviceId}
                  icon={icon}
                  costConfig={costConfig}
                  title={name || title}
                  onClick={this.onIntegrationClick(integration, expanded)}
                >
                  {expanded ? this.renderIntegrationDetails(integration) : null}
                </Integration>
              )
            })}
          </div>
        </div>
      </Fragment>
    )
  }

  renderIntegrationDetails(integration) {
    const {serviceId, id, api, costConfig: {accounts}} = integration
    const {
      integrationCosts,
      isCostsFetching,
      disconnectIntegration
    } = this.props

    return (
      <div className='integration_details'>
        {this.renderIntegrationLink(integration)}
        <div className='integration_details_container'>
          <div className='integration_details_table'>
            {api && accounts ? (<div className='integration_details_table_title'>
              Recent costs
            </div>) : null}
            <Table
              className='integration_table'
              loading={isCostsFetching}
              data={integrationCosts}
              empty={
                <div className='channel-integration-view_authorized_table_empty'>
                  No data for last 7 days
                </div>
              }
            >
              <Column
                header='Date'
                cell={data => <Cell format='date'>{data.day}</Cell>}
                width='50%'
              />
              <Column
                header={<Cell>Cost</Cell>}
                cell={data => <Cell format='currency'>{data.cost}</Cell>}
                width='50%'
              />
            </Table>
          </div>
          <div className='integration_details_other'>
            {this.renderIntegrationInfo(integration)}
            <div className='integration_actions'>
              <div
                className='button integration_disconnect'
                onClick={() => disconnectIntegration(serviceId, id)}
              >
                Disconnect
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderIntegrationLink(integration) {
    const {serviceId, costConfig: {link}} = integration

    if (serviceId !== 'google-spreadsheet' || !link) return null

    return (
      <a href={link} target='_blank' className='integration_link_container'>
        <span className='integration_link'>
          {link}
        </span>
        <span className='integration_link_action'>Go to</span>
      </a>
    )
  }

  renderIntegrationInfo(integration) {
    const {
      integrationCosts,
      isCostsFetching
    } = this.props
    const {serviceId, api, costConfig: {
      accounts,
      integrationType,
      amount,
      currency,
      integrationStartDate,
      integrationEndDate,
      period
    }} = integration

    const lastSyncDate = (!isCostsFetching && integrationCosts && integrationCosts.length)
      ? integrationCosts[0].day
      : null

    const isPercentage = integrationType === 'revenue-share' || integrationType === 'marketing-share'

    if (serviceId === 'manual-input') {
      return (
        <div className='integration_info'>
          <div className='integration_info_row'>
            <div className='integration_info_title'>
              Cost Type
            </div>
            <div className='integration_info_value'>
              {integrationTypes[integrationType]}
            </div>
          </div>
          <div className='integration_info_row'>
            <div className='integration_info_title'>
              Amount
            </div>
            <div className='integration_info_value'>
              <NumberFormat
                value={isPercentage ? amount / 100 : amount}
                format={isPercentage ? 'percent' : 'currency'}
                currency={isPercentage ? null : currency.toUpperCase()}
              />
            </div>
          </div>
          <div className='integration_info_row'>
            <div className='integration_info_title'>
              Starts On
            </div>
            <div className='integration_info_value'>
              {moment(integrationStartDate).format('DD MMMM YYYY')}
            </div>
          </div>
          <div className='integration_info_row'>
            <div className='integration_info_title'>
              Ends On
            </div>
            <div className='integration_info_value'>
              {moment(integrationEndDate).format('DD MMMM YYYY')}
            </div>
          </div>
          {period ? (
            <div className='integration_info_row'>
              <div className='integration_info_title'>
                TimePeriod
              </div>
              <div className='integration_info_value'>
                {period}
              </div>
            </div>
          ) : null}
          <div className='integration_info_row'>
            <div className='integration_info_title'>
              Last Sync
            </div>
            <div className='integration_info_value'>
              <span className='channel-integration-view_authorized_last-sync'>
                {lastSyncDate ? <TimeAgo date={moment(lastSyncDate).toDate()} /> : 'No data'}
              </span>
            </div>
          </div>
        </div>
      )
    }

    if (api && accounts) {
      return (
        <Fragment>
          <div className='integration_details_table_title'>
            Connected accounts
          </div>
          <div className='integration_details_table'>
            <Table
              className='integration_table'
              data={accounts}
            >
              <Column
                header='Id'
                cell={data => <Cell>{data.id}</Cell>}
                width='30%'
              />
              <Column
                header='Name'
                cell={data => <Cell>{data.name}</Cell>}
                width='70%'
              />
            </Table>
          </div>
          <div className='integration_info'>
            <div className='integration_info_row'>
              <div className='integration_info_title'>
                Last Sync
              </div>
              <div className='integration_info_value'>
                <span className='channel-integration-view_authorized_last-sync'>
                  {lastSyncDate ? <TimeAgo date={moment(lastSyncDate).toDate()} /> : 'No data'}
                </span>
              </div>
            </div>
          </div>
        </Fragment>
      )
    }

    return null
  }

  onIntegrationClick = (integration, expanded) => () => {
    const {
      authorizationURLParams,
      channelGroupId,
      channelId,
      showAddNewSpreadSheet,
      showAddManualInput,
      showAddCriteo,
      currentSite,
      pushState
    } = this.props
    const {connected, serviceId} = integration
    const authorizationURL = `${authorizationURLParams.prefix}${serviceId}${authorizationURLParams.postfix}`

    if (!connected && serviceId === 'google-spreadsheet') {
      return showAddNewSpreadSheet({currentSite, channel: {channelGroupId, channelId}})
    }

    if (!connected && serviceId === 'manual-input') {
      return showAddManualInput({currentSite, channel: {channelGroupId, channelId}})
    }

    if (!connected && serviceId === 'criteo') {
      return showAddCriteo({currentSite})
    }

    if (!connected) {
      window.location = authorizationURL
      return false
    }

    if (expanded) {
      pushState(`/settings/channels/${channelGroupId}/${channelId}/`)
    } else if (connected) {
      pushState(`/settings/channels/${channelGroupId}/${channelId}/${integration.id}`)
    }
  }
}

const mapStateToProps = (state, props) => {
  const {params: {channelGroupId, channelId, integrationId}} = props
  const {protocol, host} = window.location
  const {pathname} = props.location
  const integrations = getChannelIntegrations(state, channelGroupId, channelId)
  const isBusy = state.integrations.isIntegrationDeleting || state.integrations.isIntegrationsFetching
  const groupedIntegrations = getGroupedIntegrations(state)

  return {
    today: state.today,
    channelGroupId,
    channelId,
    integrationId,
    currentSite: getCurrentSite(state),
    currentMerchant: getCurrentMerchant(state),
    authorizationURLParams: getAuthorizationURLParams(state, `${protocol}//${host}${pathname}`),
    mappings: getChannelMappings(state, channelGroupId, channelId),
    isCostsFetching: state.integrations.isIntegrationCostsFetching,
    integrationCosts: getIntegrationCosts(state, integrationId),
    integrations,
    groupedIntegrations,
    isBusy
  }
}

export default connect(mapStateToProps, {
  fetchMappingsForChannel,
  fetchIntegrations,
  fetchIntegrationInfo,
  fetchIntegrationCosts,
  disconnectIntegration,
  showAddNewSpreadSheet,
  showAddManualInput,
  showAddCriteo,
  pushState
})(SettingsChannelsView)



// WEBPACK FOOTER //
// ./client/views/SettingsChannelsView/index.js